import Vue from 'vue';
import MessageNotification from '@/components/messageNotification/index.vue';

// 通知实例数组（按添加顺序存储，最新的在最后）
let notificationInstances = [];
let seed = 1;

/**
 * 获取新通知的偏移量（新通知在底部）
 */
const getNewOffset = () => {
	let offset = 20; // 基础偏移量

	// 累加所有已存在通知的高度
	for (let i = 0; i < notificationInstances.length; i++) {
		const instance = notificationInstances[i];
		if (instance.$el && instance.$el.offsetHeight) {
			offset += instance.$el.offsetHeight + 16;
		}
	}

	return offset;
};

/**
 * 更新所有通知的偏移量（从下往上重新排列）
 * 最底部的是最新通知
 */
const updateOffsets = () => {
	let offset = 20;

	// 按添加顺序遍历（最早的在上方，最新的在底部）
	for (let i = 0; i < notificationInstances.length; i++) {
		const instance = notificationInstances[i];
		if (instance && typeof instance.currentOffset !== 'undefined') {
			instance.currentOffset = offset;
			offset += instance.$el?.offsetHeight + 16 || 0;
		}
	}
};

/**
 * 移除实例
 */
const removeInstance = (instance) => {
	const index = notificationInstances.indexOf(instance);
	if (index !== -1) {
		notificationInstances.splice(index, 1);
		updateOffsets();
	}
};

/**
 * 创建通知
 */
const MessageNotificationFn = (options = {}) => {
	if (typeof options === 'string') {
		options = { message: options };
	}

	if (!options.name) {
		console.error('MessageNotification: name is required');
		return;
	}
	if (!options.message) {
		console.error('MessageNotification: message is required');
		return;
	}

	const id = `notification_${seed++}`;

	const NotificationConstructor = Vue.extend(MessageNotification);
	const instance = new NotificationConstructor({
		propsData: {
			title: options.title || '新消息提醒',
			name: options.name,
			message: options.message,
			avatar: options.avatar || '',
			duration: options.duration !== undefined ? options.duration : 5000,
			showProgress: options.showProgress !== undefined ? options.showProgress : true,
			offset: options.offset || 20,
			onClick: options.onClick || null,
			onClose: options.onClose || null
		}
	});

	instance.id = id;
	instance.vm = instance.$mount();
	instance.vm.visible = true;

	// 将新通知添加到数组末尾（最新的在最后）
	notificationInstances.push(instance);

	// 计算新通知的偏移量（在底部）
	instance.currentOffset = getNewOffset();

	document.body.appendChild(instance.vm.$el);

	instance.vm.$on('close', () => {
		removeInstance(instance);
	});

	// console.log('Notification created:', {
	// 	id,
	// 	position: notificationInstances.length,
	// 	offset: instance.currentOffset,
	// 	props: {
	// 		title: options.title,
	// 		name: options.name,
	// 		message: options.message,
	// 		duration: options.duration
	// 	}
	// });

	return instance.vm;
};

MessageNotificationFn.closeAll = () => {
	notificationInstances.forEach((instance) => {
		if (instance && instance.close) {
			instance.close();
		}
	});
	notificationInstances = [];
};

export default MessageNotificationFn;
